import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card scorecard-container" }
const _hoisted_2 = {
  key: 0,
  class: "card-body"
}
const _hoisted_3 = { class: "col-md-12" }
const _hoisted_4 = { class: "switch" }
const _hoisted_5 = ["checked"]
const _hoisted_6 = {
  key: 1,
  class: "card-body"
}
const _hoisted_7 = { class: "col-md-12" }
const _hoisted_8 = { class: "d-flex justify-content-between align-items-center pb-4" }
const _hoisted_9 = { class: "d-flex justify-content-start align-items-center" }
const _hoisted_10 = { class: "mx-2" }
const _hoisted_11 = ["value"]
const _hoisted_12 = ["disabled", "onClick"]
const _hoisted_13 = { class: "list-unstyled" }
const _hoisted_14 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_15 = { class: "px-2" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  key: 2,
  class: "card-body"
}
const _hoisted_19 = { class: "col-md-12" }
const _hoisted_20 = {
  key: 0,
  class: "text-primary position-relative float-end d-flex justify-content-between align-items-center"
}
const _hoisted_21 = { class: "comment-bubble" }
const _hoisted_22 = { class: "list-unstyled pt-2" }
const _hoisted_23 = {
  key: 0,
  class: "d-flex justify-content-between align-items-center"
}
const _hoisted_24 = { class: "px-4 w-100" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = {
  key: 1,
  class: "d-flex align-items-center"
}
const _hoisted_30 = { class: "px-4 w-100" }
const _hoisted_31 = { class: "list-unstyled" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = {
  key: 0,
  class: "m-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal = _resolveComponent("modal")!
  const _component_create_question = _resolveComponent("create-question")!
  const _component_scenario_field = _resolveComponent("scenario-field")!
  const _component_edit_question = _resolveComponent("edit-question")!
  const _component_VueDraggableNext = _resolveComponent("VueDraggableNext")!
  const _component_dynamic_form = _resolveComponent("dynamic-form")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.scenario_obj.getStatus() === _ctx.ScenarioStatus.DRAFT || _ctx.scenario_obj.getStatus() === _ctx.ScenarioStatus.EDITING)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("label", _hoisted_4, [
                _createElementVNode("input", {
                  type: "checkbox",
                  checked: _ctx.scenario_obj.data.is_participant_feedback_enabled,
                  onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.enableParticipantFeedback && _ctx.enableParticipantFeedback(...args)))
                }, null, 40, _hoisted_5),
                _cache[6] || (_cache[6] = _createElementVNode("span", { class: "slider round" }, null, -1))
              ]),
              _cache[7] || (_cache[7] = _createElementVNode("span", { class: "slider-text d-inline-block" }, "Include Participant Feedback", -1))
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.scenario_obj.data.is_participant_feedback_enabled && (_ctx.scenario_obj.getStatus() === _ctx.ScenarioStatus.DRAFT || _ctx.scenario_obj.getStatus() === _ctx.ScenarioStatus.EDITING))
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _cache[11] || (_cache[11] = _createElementVNode("label", { class: "col-form-label text-sm-right" }, "Rubric", -1)),
                  _createElementVNode("div", _hoisted_10, [
                    _withDirectives(_createElementVNode("select", {
                      class: "form-control",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedRubric) = $event))
                    }, [
                      _cache[8] || (_cache[8] = _createElementVNode("option", {
                        hidden: "",
                        disabled: "",
                        selected: ""
                      }, "Select a Rubric", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rubrics, (item, index) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: index,
                          value: item.id
                        }, _toDisplayString(item.name), 9, _hoisted_11))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.selectedRubric]
                    ])
                  ]),
                  _createVNode(_component_modal, {
                    size: "modal-lg",
                    modelValue: _ctx.previewRubric,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.previewRubric) = $event)),
                    "allow-close": ""
                  }, {
                    trigger: _withCtx((triggerProps) => [
                      _createElementVNode("button", {
                        disabled: _ctx.selectedRubric == null,
                        onClick: triggerProps.click,
                        class: "btn btn-primary"
                      }, _cache[9] || (_cache[9] = [
                        _createElementVNode("i", { class: "fa fa-eye" }, null, -1)
                      ]), 8, _hoisted_12)
                    ]),
                    header: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.rubrics.find((i)=>i.id === _ctx.selectedRubric).name), 1)
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("ul", _hoisted_13, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rubrics.find((i)=>i.id === _ctx.selectedRubric).questions, (item, index) => {
                          return (_openBlock(), _createElementBlock("li", {
                            class: _normalizeClass(["px-4 py-2", index+1 === _ctx.rubrics.find((i)=>i.id === _ctx.selectedRubric).questions.length ? 'border-0' : 'border-bottom']),
                            key: index
                          }, [
                            _createElementVNode("div", _hoisted_14, [
                              _createElementVNode("div", _hoisted_15, _toDisplayString(item.question), 1)
                            ])
                          ], 2))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createElementVNode("button", {
                    disabled: _ctx.selectedRubric == null,
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.selectRubric && _ctx.selectRubric(...args))),
                    class: "ms-2 btn btn-primary"
                  }, _cache[10] || (_cache[10] = [
                    _createElementVNode("i", { class: "fa fa-plus" }, null, -1)
                  ]), 8, _hoisted_16)
                ]),
                (_ctx.participant_feedback)
                  ? (_openBlock(), _createBlock(_component_create_question, {
                      key: 0,
                      onUpdate: _ctx.newQuestion,
                      participant_feedback: _ctx.participant_feedback,
                      form_type: 'participant_feedback'
                    }, {
                      trigger: _withCtx((triggerProps) => [
                        _createElementVNode("button", {
                          onClick: triggerProps.click,
                          class: "btn btn-primary"
                        }, _cache[12] || (_cache[12] = [
                          _createElementVNode("i", { class: "fa fa-plus" }, null, -1),
                          _createTextVNode(" Create Question ")
                        ]), 8, _hoisted_17)
                      ]),
                      _: 1
                    }, 8, ["onUpdate", "participant_feedback"]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.participant_feedback)
                ? (_openBlock(), _createBlock(_component_scenario_field, {
                    key: 0,
                    type: "editor",
                    modelValue: _ctx.participant_feedback.data.instructions,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.participant_feedback.data.instructions) = $event)),
                    field: "instructions",
                    "can-edit": true,
                    onSave: _ctx.updateInstructions
                  }, null, 8, ["modelValue", "onSave"]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.participant_feedback && _ctx.scenario_obj.data.is_participant_feedback_enabled)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              ((_ctx.scenario.data.status !== _ctx.ScenarioStatus.DRAFT) && (_ctx.scenario.data.reviewer_user_id !== null) && _ctx.showCommentBubble)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _createElementVNode("span", _hoisted_21, [
                      _createTextVNode(_toDisplayString(_ctx.scenario?.getCommentsByField(_ctx.field).length > 0 ? _ctx.scenario?.getCommentsByField(_ctx.field).length : ''), 1),
                      _cache[13] || (_cache[13] = _createElementVNode("i", {
                        class: "fas fa-2x fa-comment-dots",
                        title: "View or Read Comments"
                      }, null, -1))
                    ])
                  ]))
                : _createCommentVNode("", true),
              _cache[21] || (_cache[21] = _createElementVNode("h4", { class: "text-secondary" }, "Questions:", -1)),
              _createElementVNode("ul", _hoisted_22, [
                _createVNode(_component_VueDraggableNext, {
                  modelValue: _ctx.participant_feedback.data.questions,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.participant_feedback.data.questions) = $event)),
                  onChange: _ctx.reorder,
                  sort: _ctx.scenario_obj.getStatus() !== _ctx.ScenarioStatus.PUBLISHED && _ctx.scenario_obj.getStatus() !== _ctx.ScenarioStatus.ARCHIVED
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.participant_feedback.data.questions, (item, index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: _normalizeClass(["px-4 py-2 border-bottom", {'border-0':index+1 === _ctx.participant_feedback.data.questions.length,'bg-lighter':item.rubric}]),
                        key: index
                      }, [
                        (item.question)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                              _cache[16] || (_cache[16] = _createElementVNode("i", { class: "text-primary fas fa-bars" }, null, -1)),
                              _createElementVNode("div", _hoisted_24, _toDisplayString(item.question.short_description), 1),
                              (_openBlock(), _createBlock(_component_edit_question, {
                                participant_feedback: _ctx.participant_feedback,
                                question: item.question,
                                onUpdateQuestionData: _ctx.loadQuestions,
                                key: item.question.id,
                                form_type: 'participant_feedback'
                              }, {
                                trigger: _withCtx((triggerProps) => [
                                  (_ctx.scenario_obj.getStatus() === _ctx.ScenarioStatus.DRAFT || _ctx.scenario_obj.getStatus() === _ctx.ScenarioStatus.EDITING || _ctx.userIsAdmin)
                                    ? (_openBlock(), _createElementBlock("i", {
                                        key: 0,
                                        onClick: triggerProps.click,
                                        class: "cursor-pointer text-primary fa fa-edit"
                                      }, null, 8, _hoisted_25))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1032, ["participant_feedback", "question", "onUpdateQuestionData"])),
                              _cache[17] || (_cache[17] = _createTextVNode("   ")),
                              (_ctx.scenario_obj.getStatus() === _ctx.ScenarioStatus.DRAFT || _ctx.scenario_obj.getStatus() === _ctx.ScenarioStatus.EDITING || (_ctx.scenario_obj.getStatus() === _ctx.ScenarioStatus.APPROVED && _ctx.userIsAdmin))
                                ? (_openBlock(), _createElementBlock("i", {
                                    key: 0,
                                    onClick: ($event: any) => (_ctx.showDeleteQuestionModal(item.id)),
                                    class: "cursor-pointer text-primary fa fa-trash"
                                  }, null, 8, _hoisted_26))
                                : _createCommentVNode("", true),
                              _createVNode(_component_modal, {
                                modelValue: _ctx.deleteQuestion[item.id],
                                "onUpdate:modelValue": ($event: any) => ((_ctx.deleteQuestion[item.id]) = $event)
                              }, {
                                header: _withCtx(() => _cache[14] || (_cache[14] = [
                                  _createTextVNode("Permanently Delete Question")
                                ])),
                                default: _withCtx(() => [
                                  _cache[15] || (_cache[15] = _createElementVNode("p", null, "Are you sure you want to delete this Question?", -1)),
                                  _createElementVNode("button", {
                                    class: "btn btn-xs btn-secondary-alt float-end",
                                    onClick: ($event: any) => (_ctx.showDeleteQuestionModal(item.id))
                                  }, "Cancel", 8, _hoisted_27),
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-primary btn-xs",
                                    onClick: ($event: any) => (_ctx.removeQuestion(item.question.id,index))
                                  }, "Permanently Delete", 8, _hoisted_28)
                                ]),
                                _: 2
                              }, 1032, ["modelValue", "onUpdate:modelValue"])
                            ]))
                          : _createCommentVNode("", true),
                        (item.rubric)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                              _cache[20] || (_cache[20] = _createElementVNode("i", { class: "text-primary fas fa-bars" }, null, -1)),
                              _createElementVNode("div", _hoisted_30, [
                                _createElementVNode("strong", null, "Rubric: " + _toDisplayString(item.rubric.name), 1),
                                _createElementVNode("ul", _hoisted_31, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.rubric.questions, (rubricItem, index) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                      class: _normalizeClass(["py-2 border-bottom", {'border-0':index+1 === item.rubric.questions.length}]),
                                      key: index
                                    }, _toDisplayString(rubricItem.short_description), 3))
                                  }), 128))
                                ])
                              ]),
                              (_ctx.scenario_obj.getStatus() === _ctx.ScenarioStatus.DRAFT || _ctx.scenario_obj.getStatus() === _ctx.ScenarioStatus.EDITING || (_ctx.scenario_obj.getStatus() === _ctx.ScenarioStatus.APPROVED && _ctx.userIsAdmin))
                                ? (_openBlock(), _createElementBlock("i", {
                                    key: 0,
                                    onClick: ($event: any) => (_ctx.showDeleteRubricModal(item.id)),
                                    class: "cursor-pointer text-primary fa fa-trash"
                                  }, null, 8, _hoisted_32))
                                : _createCommentVNode("", true),
                              _createVNode(_component_modal, {
                                modelValue: _ctx.deleteRubric[item.id],
                                "onUpdate:modelValue": ($event: any) => ((_ctx.deleteRubric[item.id]) = $event)
                              }, {
                                header: _withCtx(() => _cache[18] || (_cache[18] = [
                                  _createTextVNode("Permanently Delete This Rubric")
                                ])),
                                default: _withCtx(() => [
                                  _cache[19] || (_cache[19] = _createElementVNode("p", null, "Are you sure you want to delete this Rubric?", -1)),
                                  _createElementVNode("button", {
                                    class: "btn btn-xs btn-secondary-alt float-end",
                                    onClick: ($event: any) => (_ctx.showDeleteRubricModal(item.id))
                                  }, "Cancel", 8, _hoisted_33),
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-primary btn-xs",
                                    onClick: ($event: any) => (_ctx.removeRubric(item.id,index))
                                  }, "Permanently Delete", 8, _hoisted_34)
                                ]),
                                _: 2
                              }, 1032, ["modelValue", "onUpdate:modelValue"])
                            ]))
                          : _createCommentVNode("", true)
                      ], 2))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange", "sort"])
              ]),
              _createVNode(_component_dynamic_form, {
                class: "mt-4",
                label: "Participant Feedback Preview",
                instructions: _ctx.participant_feedback.data.instructions,
                questions: _ctx.participant_feedback.data.questions
              }, null, 8, ["instructions", "questions"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.scenario_obj.data.is_participant_feedback_enabled && (_ctx.scenario_obj.getStatus() === _ctx.ScenarioStatus.PUBLISHED || _ctx.scenario_obj.getStatus() === _ctx.ScenarioStatus.ARCHIVED))
      ? (_openBlock(), _createElementBlock("div", _hoisted_35, _cache[22] || (_cache[22] = [
          _createElementVNode("p", null, "Participant Feedback not enabled.", -1)
        ])))
      : _createCommentVNode("", true),
    _createVNode(_component_Loading, {
      active: _ctx.loading,
      "is-full-page": false
    }, null, 8, ["active"])
  ], 64))
}